export const SET_SUPPLIER_ASSESSMENT_DETAILS =
  "SET_SUPPLIER_ASSESSMENT_DETAILS";

export const SET_SUPPLIER_STAKEHOLDERS_LIST = "SET_SUPPLIER_STAKEHOLDERS_LIST";

// ------------------ Company Documents ------------------------
export const SET_SUPPLIER_SURVEY_DOCUMENTS = "SET_SUPPLIER_SURVEY_DOCUMENTS";
